export const normalizeOnboardingPath = path => path.replace(/\/$/, "").replace(/\.html$/, "");
export const isPlanningPage = path => [
  "on-boarding", "add-a-goal", "add-emergency-fund", "add-other-goal", "your-plan",
  "what-financial-freedom-could-look-like", "financial-freedom-calculator",
  "financial-freedom-progress-results", "financial-freedom-monthly-amount",
  "make-your-first-investment",
].includes(normalizeOnboardingPath(path).replace(/^\/on-boarding\//, "")) && path.startsWith("/on-boarding/");

const PROFILE_STEP = "/on-boarding/on-boarding";
const ADD_A_GOAL = "/on-boarding/add-a-goal";

// Users pick a goal first; the income/date-of-birth step comes only once they open a goal flow.
export function planningDestination(login) {
  if (login?.onboarding_profile_complete !== true) return ADD_A_GOAL;
  if (typeof login.has_goal !== "boolean") throw new Error("We could not check your goals. Please try again.");
  return login.has_goal ? "/on-boarding/your-plan" : ADD_A_GOAL;
}

// Only same-origin planning pages (never the profile step itself) are valid places to return to.
export function safeNext(value) {
  if (typeof value !== "string" || !value.startsWith("/on-boarding/")) return null;
  const url = new URL(value, "https://planning.invalid");
  if (url.origin !== "https://planning.invalid") return null;
  if (normalizeOnboardingPath(url.pathname) === PROFILE_STEP || !isPlanningPage(url.pathname)) return null;
  return url.pathname + url.search;
}

export const profileStepFor = (target) => `${PROFILE_STEP}?next=${encodeURIComponent(target)}`;

export function onboardingEntryRedirect(location, login) {
  const queryStart = location.indexOf("?");
  const rawPath = queryStart === -1 ? location : location.slice(0, queryStart);
  const search = queryStart === -1 ? "" : location.slice(queryStart);
  const path = normalizeOnboardingPath(rawPath);
  const aliases = {
    "/on-boarding/on-boarding-old": "/on-boarding/on-boarding",
    "/on-boarding/financial-freedom-monthly-amount-1": "/on-boarding/financial-freedom-monthly-amount",
    "/on-boarding/loading": "/on-boarding/financial-freedom-progress-results",
    "/on-boarding/loading-ii": "/on-boarding/financial-freedom-progress-results",
  };
  if (aliases[path]) return aliases[path];
  if (!isPlanningPage(path)) return null;
  if (login?.onboarding_profile_complete !== true) {
    return [PROFILE_STEP, ADD_A_GOAL].includes(path) ? null : profileStepFor(rawPath + search);
  }
  if (path === PROFILE_STEP) return safeNext(new URLSearchParams(search).get("next")) || planningDestination(login);
  if (["/on-boarding/your-plan", "/on-boarding/make-your-first-investment"].includes(path)) {
    if (typeof login.has_goal !== "boolean") throw new Error("We could not check your goals. Please try again.");
    if (!login.has_goal) return "/on-boarding/add-a-goal";
  }
  return null;
}
